<template>
<div class="chat-contact" style="">
  <v-toolbar card color="white">    
    <v-text-field
    flat
    solo
    prepend-icon="search"
    placeholder="Search"
    v-model="search"
    hide-details
    clearable
    :loading="loading"
    ></v-text-field>  
    <v-spacer></v-spacer>
    <router-link dark :to="{path: '/rbac/user/form'}">
      <v-btn :loading="loading" color="cyan" fab small dark >                               
        <v-icon class="white--text">add</v-icon>        
      </v-btn>    
    </router-link>                                                                     
  </v-toolbar>
  <v-divider></v-divider>  
  <div class="branch-scroll" >         
    <v-list two-line class="chat-contact--list" style="margin-top:-10px;">        
      <template v-for="(item, index) in users">
        <v-divider :key="index"></v-divider>
        <v-list-tile avatar :key="item.username + index" :to="contactRoute(item.id)">
          <v-list-tile-avatar :color="randomColor()">            
            <img :src="item.avatar" v-if="item.avatar">
            <span v-else class="white--text headline">{{firstLetter(item.username)}}</span>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title :class="item.status === 10 ? 'indigo--text':'grey--text'"> 
              {{item.username}}
            </v-list-tile-title>
            <v-list-tile-sub-title>
              {{item.roles.length !== 0 ? item.roles:null}}
            </v-list-tile-sub-title>
          </v-list-tile-content>          
        </v-list-tile>        
      </template>     
      <v-list-tile v-if="users.length === 0 && startup" class="warning white--text">
        <v-list-tile-content>
          No Result
        </v-list-tile-content>
      </v-list-tile>
      <v-divider v-else></v-divider>          
    </v-list>                   
    <div class="pa-2" v-if="loadmoreOn">
      <v-btn block color="info" :loading="loading" small dark @click="loadmore">load more ...</v-btn>
    </div>
  </div>    
</div>
</template>

<script>
import user     from '@/apps/admin/models/User';
import colors   from 'vuetify/es5/util/colors';

let model = new user();

export default {
  components: {    
    
  },
  data: () => ({    
    startup : false,
    users : [],
    count : 0,
    search : null,
    loading: false,
    page  : 1,
    selected : [],
    loading:false,
  }),
  watch:{
    search: function(newVal){
      this.loading = true;
      model.all({'UserSearch[username]':newVal}).then( res => {
          this.page  = 1;
          this.users = res.data;          
          this.count = res.count;   
          this.loading = false;
      });
    }
  },
  created(){
    this.init();
  },
  mounted(){
    
    
    /*var container = document.getElementById("contact-scroll");
    
    container.addEventListener('ps-y-reach-end', function () {
      console.log('mantap neeehhh');
//      reachEvent.textContent = 'ps-x-reach-end';
    });*/
  },
  
  computed: {    
    loadmoreOn(){
      return this.users.length < this.count;
    }
    /*users () {
      return getUser();
    }*/
  },
  methods: {
    init(){      
      this.startup = true;
      this.loading = true;
      model.all({page:this.page}).then(res => {
        if(res.data){
          this.users = res.data;
          this.count = res.count;        
          this.loading = false;
        }  
      });
    },
    loadmore(){
      this.loading = true; this.page++;
      model.all({page:this.page}).then(res => {
        this.users = [...this.users ,...res.data];        
        this.loading = false;
      });
    },
    contactRoute (id) {
      return {path:'/rbac/user', query: {id: id}};
    },
    firstLetter (name) {
      return name.charAt(0);
    },
    userStatusColor (item) {
      return (item.active) ? 'green' : 'grey';
    },
    randomColor(){
      var randomArray   = colors;
      var color = _.sample(randomArray);     
      return color.base === undefined ? 'info':color.base;
    },
    
  }  
};
</script>
<style>
  #contact-scroll{
      height: calc(100vh - 152px);      
      overflow-y: auto;      
      padding-bottom: 0px;
  }
</style>
